"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORT_MESSAGE_DIRECTIONS = exports.zListSupportInquiriesQuery = exports.zReplySupportInquiryRequest = exports.zCreateAppSupportInquiryRequest = exports.zCreateSupportInquiryRequest = exports.zSupportInquiryReason = exports.SUPPORT_INQUIRY_REASONS = exports.zSupportInquiryStatus = exports.SUPPORT_INQUIRY_STATUSES = exports.zSupportInquirySource = exports.SUPPORT_INQUIRY_SOURCES = void 0;
const zod_1 = require("zod");
exports.SUPPORT_INQUIRY_SOURCES = ["website", "app"];
exports.zSupportInquirySource = zod_1.z.enum(exports.SUPPORT_INQUIRY_SOURCES);
exports.SUPPORT_INQUIRY_STATUSES = ["new", "replied"];
exports.zSupportInquiryStatus = zod_1.z.enum(exports.SUPPORT_INQUIRY_STATUSES);
// Adapted from scanvato.com/contact's own "reason" options to this
// product — not a fixed vocabulary the DB enforces, just what both contact
// forms (bay2bill-web and the in-app Support page) offer.
exports.SUPPORT_INQUIRY_REASONS = ["sales_access", "technical", "billing", "other"];
exports.zSupportInquiryReason = zod_1.z.enum(exports.SUPPORT_INQUIRY_REASONS);
/** The public, anonymous submission from bay2bill-web — requires a solved
 * captcha (see apps/api/src/support/captcha.ts), since it has no session to
 * lean on for bot resistance. */
exports.zCreateSupportInquiryRequest = zod_1.z.object({
    name: zod_1.z.string().trim().min(1),
    email: zod_1.z.string().trim().toLowerCase().email(),
    reason: exports.zSupportInquiryReason,
    subject: zod_1.z.string().trim().min(1),
    message: zod_1.z.string().trim().min(1),
    captchaToken: zod_1.z.string().min(1),
    captchaAnswer: zod_1.z.number().int(),
});
/** The authenticated in-app submission — name/email come from the session,
 * not the request body, so there's nothing to spoof and no captcha needed. */
exports.zCreateAppSupportInquiryRequest = zod_1.z.object({
    reason: exports.zSupportInquiryReason,
    subject: zod_1.z.string().trim().min(1),
    message: zod_1.z.string().trim().min(1),
});
exports.zReplySupportInquiryRequest = zod_1.z.object({
    replyBody: zod_1.z.string().trim().min(1),
});
exports.zListSupportInquiriesQuery = zod_1.z.object({
    status: exports.zSupportInquiryStatus.optional(),
    source: exports.zSupportInquirySource.optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    offset: zod_1.z.coerce.number().int().min(0).default(0),
});
exports.SUPPORT_MESSAGE_DIRECTIONS = ["inbound", "outbound"];
//# sourceMappingURL=support.js.map